module.exports = __webpack_public_path__ + "resources/icon-menu.5e1388d57615a873.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-header/img/icon-menu.png
// module id = 403
// module chunks = 0 1 2 3 4